export const patientAvailabilities = [
  {
    id: 1,
    name: 'Meet 1x/week',
    description: null,
    createdAt: '2019-09-09T20:48:56.840Z',
    updatedAt: '2019-09-09T20:48:56.840Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Meet 2x/week',
    description: null,
    createdAt: '2019-09-09T20:48:56.840Z',
    updatedAt: '2019-09-09T20:48:56.840Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Meet 3x/week',
    description: null,
    createdAt: '2019-09-09T20:48:56.840Z',
    updatedAt: '2019-09-09T20:48:56.840Z',
    createdBy: null,
    updatedBy: null,
  },
];
